import React from "react";
import { useAuth } from "../context/AuthContext";
import { LogIn } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  return (
    <section className="mx-auto max-w-md px-4 py-24 text-center">
      <div className="tag-pill mb-4 mx-auto"><LogIn size={12}/> Accesso admin</div>
      <h1 className="font-display text-5xl uppercase">Login</h1>
      <p className="mt-3 text-white/70">Accedi con Google per gestire il circolo.</p>
      {user ? (
        <div className="mt-6 text-white">Sei già collegato come <b>{user.email}</b></div>
      ) : (
        <button onClick={login} className="brutal-btn brutal-btn-primary mt-8" data-testid="google-login">
          <LogIn size={16}/> Accedi con Google
        </button>
      )}
    </section>
  );
}
